import { DI } from '@intigral/constant/config/DIContainer';
import { IAcquireLockUseCase } from '../../core/usecases/streamharness/AcquireLock';
import { container } from '../../DataDomain';
import {
    IAcquireLockRequestBody,
    IAcquireLockRequestHeaders,
    IAcquireLockRequestParams,
    IAcquireLockResponse,
    IDeleteLockRequestParams,
} from '../../entity/interface/iStreamHarness';
import { IRefreshLockUseCase } from '../../core/usecases/streamharness/RefreshLock';
import { IDeleteLockUseCase } from '../../core/usecases/streamharness/DeleteLock';

export interface iStreamHarnessService {
    acquireLock(
        params: IAcquireLockRequestParams,
        payload: IAcquireLockRequestBody,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse>;
    refreshLock(
        params: IAcquireLockRequestParams,
        payload: IAcquireLockRequestBody,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse>;
    deleteLock(params: IDeleteLockRequestParams, headers: IAcquireLockRequestHeaders): Promise<IAcquireLockResponse>;
}

export class StreamHarnessService implements iStreamHarnessService {
    // Lazy getters for dependencies to avoid circular dependencies
    private get acquireLockUseCase(): IAcquireLockUseCase {
        return container.resolve<IAcquireLockUseCase>(DI.USECASES.IAcquireLockUseCase);
    }

    private get refreshLockUseCase(): IRefreshLockUseCase {
        return container.resolve<IRefreshLockUseCase>(DI.USECASES.IRefreshLockUseCase);
    }

    private get deleteLockUseCase(): IDeleteLockUseCase {
        return container.resolve<IDeleteLockUseCase>(DI.USECASES.IDeleteLockUseCase);
    }

    constructor() {
        // No initialization needed - dependencies resolved lazily via getters
    }

    async acquireLock(
        params: IAcquireLockRequestParams,
        payload: IAcquireLockRequestBody,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse> {
        return await this.acquireLockUseCase.execute(params, payload, headers);
    }

    async refreshLock(
        params: IAcquireLockRequestParams,
        payload: IAcquireLockRequestBody,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse> {
        return await this.refreshLockUseCase.execute(params, payload, headers);
    }

    async deleteLock(
        params: IDeleteLockRequestParams,
        headers: IAcquireLockRequestHeaders
    ): Promise<IAcquireLockResponse> {
        return await this.deleteLockUseCase.execute(params, headers);
    }
}
